import React from "react";
import { IStepper } from "../../interfaces/Components/Stepper/IStepper";

import "./Stepper.scss";

export const Stepper: React.FC<IStepper> = ({ steps, currentStep, ...props }) => {

    const renderSteps = () => {
        return steps.map((description: string, index: number) => {
            const className = index === currentStep ? "current" : index < currentStep ? "complete" : null;
            return className ? 
                <li key={index} className={className}>{description}</li> : 
                <li key={index}>{description}</li>;
        });
    };

    const className = `stepper ${props.className || ''}`;
    return (
        <ul className={className}>
            {renderSteps()}
        </ul>
    );
};